import styled from "styled-components";

export const DriverFormContainer = styled.form`
    .driverBtn {
        width: 50%;
    }
`